module.exports = __webpack_public_path__ + "svg/illustration-business-call-papers.5b20b04.svg";